import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {Page} from '@/hooks/empresa/organizacion/use-businesses'

/** Create/update stay per resource: their payloads diverge (partners carry a `quotas` matrix). */
export function createRosterHooks<TEntity>(basePath: string, queryKey: string) {
  const KEY = [queryKey]

  function useList(params: {page: number; search: string}, pageSize: number, enabled = true) {
    return useQuery({
      queryKey: [...KEY, params],
      queryFn: async () =>
        (
          await api.get<Page<TEntity>>(basePath, {
            params: {page: params.page, page_size: pageSize, search: params.search || undefined},
          })
        ).data,
      enabled,
      placeholderData: (previous) => previous,
    })
  }

  function useInvalidate() {
    const queryClient = useQueryClient()
    return () => queryClient.invalidateQueries({queryKey: KEY})
  }

  function useDeactivate() {
    const invalidate = useInvalidate()
    return useMutation({
      mutationFn: async (userId: string) => (await api.post<TEntity>(`${basePath}/${userId}/deactivate`)).data,
      onSuccess: invalidate,
    })
  }

  function useReactivate() {
    const invalidate = useInvalidate()
    return useMutation({
      mutationFn: async (userId: string) => (await api.post<TEntity>(`${basePath}/${userId}/reactivate`)).data,
      onSuccess: invalidate,
    })
  }

  return {useList, useInvalidate, useDeactivate, useReactivate}
}
